import { render } from "./AuthFormView.vue?vue&type=template&id=2c250b36&scoped=true"
import script from "./AuthFormView.vue?vue&type=script&lang=js"
export * from "./AuthFormView.vue?vue&type=script&lang=js"

import "@/assets/css/AuthFormView.css?vue&type=style&index=0&id=2c250b36&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c250b36"]])

export default __exports__